import { render, staticRenderFns } from "./QuizTypedAnswerForm.vue?vue&type=template&id=780629c2&"
import script from "./QuizTypedAnswerForm.vue?vue&type=script&lang=ts&"
export * from "./QuizTypedAnswerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports